<template>
  <div>
    <SysDataTable
      v-model="selections"
      :headers="headers"
      :items="desserts"
      :height="alturaDaJanela - 150"
      :item-height="40"
      hide-default-footer
      class="elevation-1"
    >
      <template #top>
        <v-spacer></v-spacer>
        <DialogImportacao
          @atualizar-produtos-analise-mercado="getDados()"
        />
      </template>

      <template #item.acoes="{ item }">
        <v-btn
          color="primary"
          icon
          @click="dialogExpanded(item)"
        >
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>

      <template #item.mes="{ value }">
        {{ meses[value - 1] }}
      </template>

      <template #item.mes_1="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_2="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_3="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_4="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_5="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_6="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_7="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_8="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_9="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_10="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_11="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_12="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>
    </SysDataTable>

    <DialogDadosExpanded
      :item="dialog_expanded.dado"
      :dialog_expanded="dialog_expanded.ativar"
      @fechar-dialog="dialog_expanded.ativar = false"
    />
  </div>
</template>

<script>
import Responsividade from "../../../helpers/ResponsiveHeight";
import SysDataTable from '../../utils/dataTable/sysDataTable/Index.vue';
import DialogImportacao from './DialogImportacao.vue';
import ImportAPI from '../../../api/imports';
import DialogDadosExpanded from './DialogDadosExpanded.vue';
import Meses from './includes/Meses';
import Headers from "./includes/HeadersTabelaDados";

export default {
  mixins: [
    Responsividade
  ],
  components: {
    SysDataTable,
    DialogImportacao,
    DialogDadosExpanded
},
  data() {
    return {
      dialog_expanded: {
        ativar: false,
        dado: {}
      },
      selections: [],
      meses: Meses,
      headers: Headers.index,
      desserts: []
    }
  },

  created() {
    this.getDados();
  },

  methods: {
    dialogExpanded(item) {
      this.dialog_expanded.ativar = true;
      this.dialog_expanded.dado = item
    },

    getDados() {
      this.$store.dispatch("loadingAux/habilitarLoading", true);

      ImportAPI.getDadosProdutosAnaliseMercado()
        .then((response) => {
          const { message, dados, token } = response.data;
          localStorage.setItem("token", token);

          this.desserts = dados;
        })
        .catch(() => {
          this.Helpers.logout();
        })
        .finally(() => this.$store.dispatch("loadingAux/habilitarLoading", false) );

    }
  }
}
</script>

<style>

</style>
